import dayjs from 'dayjs';

import type { CurrentUserData } from 'hooks/api/use-current-user';

import { formatDate } from 'helpers/dates-formatter';

const FALLBACK_RESET_DATE_FORMAT = 'MMM D, YYYY';

export const getIsTokenUsageExempt = (
  currentUser: CurrentUserData | null | undefined
): boolean =>
  Boolean(
    currentUser?.fdUser || currentUser?.clientAdmin || currentUser?.internalUser
  );

export const getTokenLimitReachedMessage = (resetDate?: string): string =>
  resetDate
    ? `Token limit reached. Usage resets on ${resetDate}.`
    : `Token limit reached.`;

export const getFallbackResetDate = (): string =>
  formatDate(
    dayjs().add(1, 'month').startOf('month'),
    FALLBACK_RESET_DATE_FORMAT
  ) ?? '';
